import React from 'react';
import { Link } from 'react-router-dom';
import { PiBellSimpleLight } from "react-icons/pi";

export const NotificationButton = ({unreadNotifications, navigationOpen}) => {

    return (
        <li title='Benachrichtigungen'>
            <Link
                to='/notifications'
                className={'text-gray-900 hover:bg-indigo-700 hover:text-white group flex gap-x-3 rounded-md p-2 text-sm leading-6'}
            >
                <>
                    <div className={"relative inline-flex -ml-0.5"}>
                        {unreadNotifications > 0 ? (
                            <>
                                <PiBellSimpleLight
                                    aria-hidden="true"
                                    className={`text-gray-900 group-hover:text-white block h-6 w-6 mr-3 shrink-0`}
                                />
                                <span className={"absolute group-hover:border-indigo-700 group-hover:bg-white group-hover:text-indigo-700 border-[0.5px] border-red -top-1 right-2 grid min-h-[16px] min-w-[16px] translate-x-2/4 -translate-y-2/4 place-items-center rounded-full bg-red py-0 px-0 text-[8px] font-bold leading-none text-white content-['']"}>
                                    {unreadNotifications > 99 ? "99" : unreadNotifications}
                                </span>
                            </>
                        ) : (
                            <PiBellSimpleLight
                                aria-hidden="true"
                                className={`text-gray-900 group-hover:text-white block h-6 w-6 mr-3 shrink-0`}
                            />
                        )}
                        
                    </div>
                    <div className='ml-[-12px]'>
                            {(navigationOpen === 0) ? "Benachrichtigungen":""}
                    </div>
                </>
            </Link>
        </li>
        )
}